/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".box[_ngcontent-%COMP%]{display:inline-block;width:3rem;height:3rem;margin:.25rem}"];
export { styles as styles };
